module.exports = __webpack_public_path__ + "img/zaomengvr.7a118216.png";